import { render, staticRenderFns } from "./morePds.vue?vue&type=template&id=bd8dbe4a&scoped=true"
import script from "./morePds.vue?vue&type=script&lang=js"
export * from "./morePds.vue?vue&type=script&lang=js"
import style0 from "./morePds.vue?vue&type=style&index=0&id=bd8dbe4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8dbe4a",
  null
  
)

export default component.exports